module.exports = __webpack_public_path__ + "static/media/PM15.d7d51fa0.png";